import axios from "../../../axios"

export default {
  campaignSegments(campaignId) {
    return axios.post('', {
      query: `
        query {
          campaignSegments (newsletter_campaign_id: ${campaignId}) {
            categories {
              id,
              name
            }
          }
        }
      `
    })
  },
}
